import { NOTIFICATIONS_URL } from "@shared/constants";
import { _getFindingsParamsFromSearch } from "@shared/utils";

import { authPost } from "../auth/auth";

export type CreateTicketsRequest = {
  deploymentId: number;
  ticketingId: string;
  issueIds?: number[];
  searchParams?: URLSearchParams;
};

type CreateTicketsBody = { issue_ids: number[] } | undefined;

export type CreateTicketsResponse = {
  failed: {
    error: string;
    issue_id: number;
  }[];
  succeeded: {
    ticket_id: number;
    ticket_url: string;
    issue_id: number;
    external_slug: string;
  }[];
  skipped: { issue_id: number; reason: string }[];
};

export const createTickets = async (options: CreateTicketsRequest) => {
  let queryParams = new URLSearchParams();
  if (options.searchParams) {
    // Clean up search params
    queryParams = _getFindingsParamsFromSearch(options.searchParams);
  }
  if (queryParams.get("tab") === null) {
    queryParams.set("tab", "open");
  }

  return authPost<CreateTicketsBody, CreateTicketsResponse>(
    `${NOTIFICATIONS_URL}/${options.deploymentId}/ticketing/${
      options.ticketingId
    }/create_tickets?${queryParams.toString()}`,
    options.issueIds ? { issue_ids: options.issueIds } : undefined
  );
};
